import { Box } from '@chakra-ui/react';

// Brand gradient for the AI sparkle + text. Icons reference it by id —
// currentColor can't clip a gradient.
export const SPARKLE_GRADIENT_ID = 'agentforge-sparkle-gradient';
export const SPARKLE_GRADIENT_CSS = 'linear(to-br, #8A90FF, #B15FDA)';

export const SparkleGradientDef = () => (
  <Box as="svg" w="0" h="0" position="absolute" aria-hidden>
    <defs>
      <linearGradient id={SPARKLE_GRADIENT_ID} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#8A90FF" />
        <stop offset="100%" stopColor="#B15FDA" />
      </linearGradient>
    </defs>
  </Box>
);
